// =====================================================
// CITY LIST (Add Your Name form)
//
// ONE main city per State / Union Territory — "Bengaluru" already says
// Karnataka — so the form asks for the city and nothing else. There is no
// State dropdown, and the state is never shown on a card or a board.
//
// src/data/indiaCities.json is a byte-identical copy of Server/data/indiaCities.json
// (Create React App cannot import from outside src/), so the dropdown can only
// ever offer cities the server will accept. The server re-checks every
// submission against its own copy — this file is convenience, not the rule.
// =====================================================

import DATA from "../data/indiaCities.json";

// Already sorted by city in the data file; that is the order the dropdown uses.
export const INDIA_CITIES = DATA.cities.map((row) => row.city);

const CITY_SET = new Set(INDIA_CITIES);

export function isValidCity(city) {
  return Boolean(city) && CITY_SET.has(city);
}
